import { z } from 'zod';
import { parseWebApiResponse } from './common';
const nullableStringSchema = z.string().nullable().optional();
const nullableDateSchema = z.union([z.string(), z.date()]).nullable().optional();
const peopleTypeSchema = z
    .enum(['tenant', 'apartmentOwner', 'prospect', 'maintenance', 'vendor'])
    .nullable()
    .optional();
const personAssociationSchema = z
    .object({
    id: z.coerce.number().optional(),
    personId: z.coerce.number().nullable().optional(),
    accountId: z.coerce.number().nullable().optional(),
    portfolioId: z.coerce.number().nullable().optional(),
    vendorCompanyId: z.coerce.number().nullable().optional(),
})
    .passthrough();
export const peoplePersonResponseSchema = z
    .object({
    id: z.coerce.number(),
    uuid: nullableStringSchema,
    firstName: nullableStringSchema,
    lastName: nullableStringSchema,
    phoneNumberCell: nullableStringSchema,
    email: nullableStringSchema,
    peopleType: peopleTypeSchema,
    status: nullableStringSchema,
    pmSystemStatus: nullableStringSchema,
    flag: z.coerce.boolean().optional(),
    createdAt: nullableDateSchema,
    updatedAt: nullableDateSchema,
    deletedAt: nullableDateSchema,
    prospectPeople: z.array(personAssociationSchema).optional().default([]),
    maintenancePeople: z.array(personAssociationSchema).optional().default([]),
    vendors: z.array(personAssociationSchema).optional().default([]),
})
    .passthrough();
// The people update runs Sequelize individual hooks, so it answers `[count, rows]`;
// older paths answer `[count]`. Only the count is read.
export const peopleUpdateResponseSchema = z.tuple([z.coerce.number()]).rest(z.unknown());
export const apartmentOwnerCreateResponseSchema = z.preprocess((data) => {
    if (data &&
        typeof data === 'object' &&
        !Array.isArray(data) &&
        !('persistedNewApartmentOwner' in data) &&
        'id' in data) {
        return { persistedNewApartmentOwner: data };
    }
    return data;
}, z.object({ persistedNewApartmentOwner: peoplePersonResponseSchema }).passthrough());
export function parsePeoplePersonResponse(data, endpoint = 'GET /api/people/:id') {
    return parseWebApiResponse(peoplePersonResponseSchema, data, endpoint);
}
export function parsePeopleCreateResponse(data) {
    return parseWebApiResponse(peoplePersonResponseSchema, data, 'POST /api/people');
}
export function parseTenantPeopleCreateResponse(data) {
    return parseWebApiResponse(peoplePersonResponseSchema, data, 'POST /api/people/tenant');
}
export function parsePeopleUpdateResponse(data) {
    return parseWebApiResponse(peopleUpdateResponseSchema, data, 'PUT /api/people');
}
export function parseApartmentOwnerCreateResponse(data) {
    return parseWebApiResponse(apartmentOwnerCreateResponseSchema, data, 'POST /api/people');
}
